import {
  CreateInterviewDocument,
  CreateInterviewMutation,
  CreateInterviewMutationVariables,
  GetApplicationInterviewsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateInterview = () => {
  const [createInterview, { loading }] = useMutation(CreateInterviewDocument, {
    extractorFn: (data: CreateInterviewMutation) => data.atsMutations.createAtsInterview,
  })

  return {
    loading,
    create(variables: CreateInterviewMutationVariables) {
      return createInterview({
        variables,
        refetchQueries: [GetApplicationInterviewsDocument],
      })
    },
  }
}
